const TechnicalLV10 = () => {
    return (
        <div>
            <p><span style={ { fontSize: "24px" } }><strong>Riepu parametru maiņa</strong></span></p>
            <p>&nbsp;</p>

            <p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;Ir atļauta riepu izmantošana ar lielāku kravnesības indeksu un ātruma simbolu, ja tie atbilst automobiļa un riepu ražotāja prasībām. Piemēram, <strong> "T"</strong> (190 km/h) vietā var izmantot <strong> "H"</strong> (210 km/h), ja tas ir pieļauts konkrētajam automobilim.</p>

            <p>&nbsp;</p>

            <p><span style={ { fontSize: "24px" } }><strong>Riepu izmēra maiņa</strong></span></p>

            <p>&nbsp;</p>

            <p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;Ja riepu izmērs tiek mainīts uz citu, nepieciešams ievērot visu normatīvo aktu, noteikumu un rekomendāciju, kā arī automobiļa, riteņu disku un riepu ražotāju prasības. Jebkurā gadījumā jāpievērš uzmanība riteņa brīvai kustībai un atbilstošai noslodzei. Riepu un riteņu izmēri, kas nav minēti automobiļa tehniskajos dokumentos, var tikt izmantoti tikai tad, ja automobiļa un riepu ražotājs tos ir apstiprinājis vai arī atbilstošā uzraugošā iestāde ir izsniegusi aprīkošanas atļauju pēc oficiāli atzīta eksperta pārbaudes.</p>

            <p>&nbsp;</p>

            <p><span style={ { fontSize: "24px" } }><strong>Riepu izmēru aizvietošana</strong></span></p>

            <p>&nbsp;</p>

            <p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;80 un 82 profila augstuma riepas ar vienādu izmēru var tikt mainītas savā starpā bez speciālas atļaujas un bez jelkāda jauna ieraksta automobiļa dokumentos, ja slodzes un ātruma indeksi ir tādi paši vai lielāki. Piemērs: <strong>155/80 R13 79T</strong> aizvieto <strong>155/82 R13 79T</strong>.</p>

            <p>&nbsp;</p>

            <p><span style={ { fontSize: "24px" } }><strong>Riepu konstrukcija</strong></span></p>

            <p>&nbsp;</p>

            <p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;Dažādas konstrukcijas riepu izmantošana automobiļiem, dzīvojamajiem vagoniņiem un piekabēm nav atļauta: riepām uz jebkura viena transportlīdzekļa ir jābūt vai nu radiālajām, vai diagonālajām. (Izņēmums: rezerves riteņa izmantošana ārkārtas, t.i. avārijas gadījumā.)</p>

            <p>&nbsp;</p>

            <p><span style={ { fontSize: "24px" } }><strong>Riteņu diski</strong></span></p>

            <p>&nbsp;</p>

            <p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;Tas pats attiecas uz <strong>riteņu disku</strong> izvēli: ir jāizmanto automobiļa ražotāja ieteiktie standarta riteņi.</p>

            <p>&nbsp;</p>

            <p><span style={ { fontSize: "24px" } }><strong>Run-flat riepas</strong></span></p>

            <p>&nbsp;</p>

            <p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;<strong>Run-flat</strong> riepas (piemēram, <em>SSR, ZP, EMT, DSST, RFT</em> u.c.) drīkst izmantot tikai tādos automobiļos, kuriem tās ir paredzējis ražotājs, un parasti tie ir aprīkoti ar riepu spiediena monitoringa (kontroles) sistēmu. Tāpat nedrīkst jaukt dažādas riepas jebkurā no automobiļa ass pozīcijām, jo standarta riepas nenodrošina <em>run-flat</em> riepu īpašības.</p>
        </div>
    );
};

export default TechnicalLV10;


